import React, { useEffect, useState } from "react";
import styled from "styled-components";
import GameServices from "./GameServices";
import Loading from "../based/Loading";
import CommonModal from "../based/Modal";

const initRateModel = {
    minThreshold: 0.02,
    maxThreshold: 0.08,
};

function ConfigThresholdModal({ show, onClose, gameId, onSave }) {
    const [rateModel, setRateModel] = useState({ ...initRateModel });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (gameId) {
            getGame(gameId);
        }
    }, [gameId]);

    const getGame = async (id) => {
        const [err, data] = await GameServices.GetGameById(id);
        if (!err && data) {
            setRateModel(data);
        } else {
            setRateModel({ ...initRateModel });
        }
    };

    const saveGame = async () => {
        setIsLoading(true);
        const [err] = await GameServices.HandleThreshold(rateModel);
        if (!err) {
            onSave();
        } else {
            console.error("Error saving game:", err);
        }
        setIsLoading(false);
    };

    return (
        <Wrapper>
            <Loading show={isLoading} msg="Đang xử lý..." />
            <CommonModal
                show={show}
                onClose={() => onClose()}
                onConfirm={() => {
                    saveGame();
                }}
            >
                <div className="form-group">
                    <label htmlFor="" className="form-label required">
                        Điểm ngưỡng trên
                    </label>
                    <input
                        type="number"
                        onChange={(e) => {
                            setRateModel({ ...rateModel, maxThreshold: +e.target.value });
                        }}
                        className="form-control"
                        value={rateModel.maxThreshold}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="" className="form-label required">
                        Điểm ngưỡng dưới
                    </label>
                    <input
                        type="number"
                        onChange={(e) => {
                            setRateModel({ ...rateModel, minThreshold: +e.target.value });
                        }}
                        className="form-control"
                        value={rateModel.minThreshold}
                    />
                </div>
            </CommonModal>
        </Wrapper>
    );
}

export default ConfigThresholdModal;

const Wrapper = styled.div``;
